import React from 'react'
import { useState, useEffect } from 'hooks'
import { connect } from 'react-redux'
import { resendConfirmationEmail, startIntro } from 'store/actions'
import { LEGAL_PAGE } from 'common/constants'
import Button from 'components/Button'
import { T } from 'components/Translations'
import Modal from '../Modal'
import { CONFIRM_EMAIL_MODAL } from '../modalTypes'
import EmailForm from './EmailForm'
import StyledConfirmEmail from './StyledConfirmEmail'

const isPublic = path => LEGAL_PAGE.test(path) || path.match(/^(\/rct)?\/logout$/)

const ConfirmEmail = ({ screenName, email, siteName, showModal, initialEmailMsg, ...actions }) => {
  const [editEmail, setEditEmail] = useState(false)

  useEffect(() => {
    if (showModal) {
      localStorage.recentlyJoined = 1
    } else if (localStorage.recentlyJoined) {
      setTimeout(actions.startIntro, 10 * 1000)
    }
  }, [showModal])

  return (
    showModal && (
      <Modal transparentBackground close={{ disabled: true }} modalId={CONFIRM_EMAIL_MODAL}>
        <StyledConfirmEmail>
          <div className="body">
            <header>
              <span className="username">{screenName}</span> <T label="confirmation/confirmEmail|noColon" />
            </header>
            <T as="p" className="confirmation-text" label="confirmation/toStartReceivingMessages" />

            <EmailForm
              editable={editEmail}
              initialEmail={email}
              initialEmailMsg={initialEmailMsg}
              onSubmit={actions.resendConfirmationEmail}
            />

            <div className="additional-information">
              <T as="p" className="text" label="confirmation/checkJunk|clean" macros={{ webHost: siteName }} />
              <Button
                fill="transparent"
                className="action"
                onClick={() => {
                  document.querySelector('.current-email').focus()
                  setEditEmail(true)
                }}
                label="confirmation/wrongEmail"
              />
              <Button fill="transparent" className="action" to="/faq" label="support/support" />
            </div>
          </div>
        </StyledConfirmEmail>
      </Modal>
    )
  )
}

const mapStateToProps = ({ myProfile, siteConfig, router, flags, responseMessages }) => ({
  screenName: myProfile.screenName,
  email: myProfile.email,
  siteName: siteConfig.siteName,
  showModal: (flags.confirmationModal || myProfile.accountStatus === 1) && !isPublic(router.location.pathname),
  initialEmailMsg: responseMessages.initialEmailMsg?.message,
})

export default connect(mapStateToProps, { resendConfirmationEmail, startIntro })(ConfirmEmail)
